/**
 * LoadingSpinner Component
 * Displays loading spinner with optional message
 * 
 * Requirements: 15.2
 */

import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  overlay?: boolean;
}

function LoadingSpinner({ size = 'medium', message, overlay = false }: LoadingSpinnerProps) {
  const content = (
    <div className={`loading-spinner-container ${overlay ? 'loading-overlay' : ''}`}>
      <div className={`loading-spinner loading-spinner-${size}`}>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );

  return content;
}

export default LoadingSpinner;
